export default __webpack_public_path__ + "static/media/coffee-cup-2.1a3dacd0.png";